'use strict';

var React = require('react');

module.exports = React.createClass({

    render: function() {
        var id = this.props.video.VimeoID;
        var src = `//player.vimeo.com/video/${id}?autoplay=1&api=1&player_id=${id}`;
        return (
            <div className='videoplayer'>
                <iframe ref         = 'iframe'
                        id          = {id}
                        src         = {src}
                        frameBorder = {0} allowFullScreen
                        title       = 'Vimeo player'
                        >
                </iframe>
            </div>
        );
    },
});



// WEBPACK FOOTER //
// ./src/components/videoplayer.jsx